// src/component/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Component }) => {
  const authToken = localStorage.getItem('authToken');
  return authToken ? <Component /> : <Navigate to="/" />;
};

export default PrivateRoute;
